<template>
  <v-content>
    <v-container my-10>
      <v-layout align-center justify-center>
        <v-progress-circular
          :size="55"
          :width="4"
          indeterminate
          color="primary"
          class="mt-12"
          v-if="getItemLoadingStatus"
        />
        <item-add-edit-form
          v-if="!getItemLoadingStatus"
          @itemEdited="isItemEdited = $event"
        ></item-add-edit-form>
      </v-layout>
      <unsaved-content-warning
        :dialog="unsavedContent"
        @redirect="redirectRoute"
      ></unsaved-content-warning>
    </v-container>
  </v-content>
</template>

<script>
import ItemAddEditForm from "@/components/items/ItemAddEditForm";
import { mapGetters } from "vuex";
import UnsavedContentWarning from "@/components/dialogs/UnsavedContentWarningDialog";

export default {
  components: {
    ItemAddEditForm,
    UnsavedContentWarning,
  },
  computed: {
    ...mapGetters(["getItemLoadingStatus"]),
  },
  data: () => ({
    unsavedContent: { active: false, route: null },
    isItemEdited: false,
  }),
  methods: {
    redirectRoute(event) {
      if (event) {
        this.$router.push(this.unsavedContent.route);
      }
      this.unsavedContent.active = false;
      this.unsavedContent.route = null;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.isItemEdited) {
      next();
    } else {
      if (this.unsavedContent.route) {
        next();
      } else {
        this.unsavedContent.active = true;
        this.unsavedContent.route = to;
        next(false);
      }
    }
  },
};
</script>
